import type { IAddress } from "@/types/address";

export type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

export type IServerError = { error: string };

export type ICookieConsent = {
  essential: {
    all: boolean;
  };
  optional: {
    analytical: boolean;
  };
};

export type IRepositoryOptions = {
  abort?: boolean;
};

export type ISortOrder = "asc" | "desc" | "";

export type IPaginated<T> = {
  page: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
  content: T[];
  statusCounts?: IStatusCount[];
};

export type IStatusCount = {
  status: string;
  count: number;
};

export type IPaginationParams = {
  totalPages: number;
  totalRecords: number;
};

export enum AuthState {
  Loading = "Loading",
  Authenticated = "Authenticated",
  Unauthenticated = "Unauthenticated",
}

export enum Period {
  All = "all",
  Week = "week",
  Month = "month",
}

export enum Currency {
  USD = "USD",
}

export type IServiceArea = {
  name: string;
  address: IAddress;
};

export type IValidatedDocument<T = Record<string, string>> = {
  valid: boolean;
  message: string;
  extractedData: Partial<T>;
  imageUrl: string;
};
